import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import { LocalizedLinksProvider } from '../context/LocaleContextProvider'

/**
 * @description keeps internal links French on French pages. The built French paths come from one static query, so
 * they're stored once for the site instead of in every page's page-data. See `frenchPaths` in gatsby-node.js.
 */
export const FrenchLinks: React.FC = ({ children }) => {
  const { frenchPaths } = useStaticQuery<{ frenchPaths: string[] }>(graphql`
    query FrenchPaths {
      frenchPaths
    }
  `)

  return <LocalizedLinksProvider frenchPaths={frenchPaths}>{children}</LocalizedLinksProvider>
}
